/**
 * Notification - Toast notification component
 *
 * Displays a temporary success/error message at the top-right of the viewport.
 *
 * @param {{ notification: { message: string, type: string } | null }} props
 */

import React from "react";
import { colors } from "../../AgenticPaymentTransactionHistory/styles";

const Notification = ({ notification }) => {
    if (!notification) return null;

    return (
        <div
            style={{
                position: "fixed",
                top: "20px",
                right: "20px",
                zIndex: 2000,
                padding: "14px 24px",
                borderRadius: "8px",
                background:
                    notification.type === "error"
                        ? colors.danger
                        : colors.success,
                color: colors.white,
                fontSize: "14px",
                fontWeight: 600,
                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                animation: "fadeIn 0.3s ease",
            }}
        >
            {notification.message}
        </div>
    );
};

export default Notification;
